import { capitalizeSentenceIfLower } from '@btime/helpers'
import React from 'react'

import { formatBlockReplies } from '../../../../containers/dynamic/presentationList/_helpers/formatBlocks'
import Bar from '../../../../components/pdf/Bar'
import Reply from './components/Reply'
import Separator from '../../../../components/pdf/Separator'
import Text from '../../../../components/pdf/Text'
import SumNoiseBlockQuestions from '../general/SumNoiseBlockQuestions'
import SumHeatBlockQuestions from '../general/SumHeatBlockQuestions'
import View from '../../../../components/pdf/View'

const customReply = (item, blocks) => {
  return (
    <>
      <SumNoiseBlockQuestions block={item} replies={blocks} />
      <SumHeatBlockQuestions block={item} replies={blocks} />
    </>
  )
}

const Replies = ({ replies }) => {
  replies = formatBlockReplies(replies)

  return replies.map(reply => <Reply key={reply.id} reply={reply} customReplyPresenter={customReply} />)
}

const RepliesSection = ({ categories }) => {
  return categories.map(category => (
    <View key={category.id} pageBreakAfter={'always'}>
      <Separator weight={8} />
      <Bar>
        <Text size="h5" bold>
          {capitalizeSentenceIfLower(category.name)}
        </Text>
      </Bar>

      <Separator weight={4} />

      <Replies replies={category.replies} />
    </View>
  ))
}

export default RepliesSection
